// Document numbers' checks as typed (Numbering.tsx in Riverstone, DocumentNumbers.tsx on the SettingsPage
// pattern): no stylesheets, so both read them.

/** The prefix the field allows (letters, digits and dashes, up to 10), and the next number as typed. */
export const prefixOk = (p: string) => /^[A-Za-z0-9-]{0,10}$/.test(p);
export const nextOk = (n: string) => /^\d{1,12}$/.test(n.trim()) && Number(n) >= 1;
